const isModified = (item) => {
  if (item) {
    if (item.__isCreated === true) { return true }
    if (item.__isModified === true) { return true }
    if (item.__IS_FILEATTACHMENT === true) { return true }
    let hasModifiedChild = false
    Object.keys(item).forEach(prop => {
      if (Array.isArray(item[prop])) {
        item[prop].forEach(x => {
          if (!hasModifiedChild) {
            if (isModified(x)) { hasModifiedChild = true }
          }
        })
      } else if (typeof item[prop] === 'object') {
        if (!hasModifiedChild) { hasModifiedChild = isModified(item[prop]) }
      }
    })
    if (hasModifiedChild) { return true }
  }
  return false
}

export {
  isModified
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/common/isModified.js